/**
 * /app/$tenantSlug/timesheet — legacy redirect → /my-time (docs/47 P1).
 *
 * The employee "My week" surface moved into the unified My Time page (Zone
 * B project allocation, with the full week grid reachable from Zone C's
 * "View week grid" link). This index route now redirects so old links /
 * bookmarks land on the merged page. The deep sub-routes
 * (timesheet/inbox, timesheet/weeks/$weekStart, timesheet/admin/projects/*)
 * are PRESERVED — only this index collapses into My Time.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/timesheet/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/my-time",
      params: { tenantSlug: params.tenantSlug },
    });
  },
});
